import { Dialog, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface MediaModalProps {
  open: boolean;
  media: string | null;
  onClose: () => void;
}

export const MediaModal = ({ open, media, onClose }: MediaModalProps) => {
  if (!media) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          padding: 2,
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius: "12px",
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ textAlign: "right" }}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {media && media.endsWith(".mp4") ? (
        <Box
          component="video"
          controls
          src={media}
          sx={{
            width: "100%",
            maxHeight: "80vh",
            objectFit: "contain",
            borderRadius: "8px",
          }}
        />
      ) : (
        <Box
          component="img"
          src={media}
          sx={{
            width: "100%",
            maxHeight: "80vh",
            objectFit: "contain",
            borderRadius: "8px",
          }}
        />
      )}
    </Dialog>
  );
};
